import { t } from '@lingui/core/macro';
import { ButtonGroup, Skeleton } from '@pocketlaw/tetris';
import { MultiselectOperator } from './MultiselectOperator';
import { useProjects } from './useProjects';
import { ClearFilter } from '../components/ClearFilter';
import { NullOperator } from '../components/NullOperator';
import { OperatorSelector } from '../components/OperatorSelector';
import { useFilter } from '../useFilter';
/**
 * Filter to use for SearchStringFilter typeof filters.
 */
export function SearchProjectFilter(props) {
    var _a;
    const { label, name, openOnNotSet } = props;
    const filter = useFilter(name);
    const selectedIds = (((_a = filter.value) === null || _a === void 0 ? void 0 : _a[filter.operator]) || []);
    const { projects, loading } = useProjects(selectedIds);
    return (<Skeleton loading={loading}>
      <ButtonGroup>
        <OperatorSelector name={name} label={label} openOnNotSet={openOnNotSet} operators={[
            {
                id: 'in',
                menuItem: t({ message: 'Is', comment: 'Search: Filter operator - is' }),
                label: t({ message: 'is', comment: 'Search: Filter operator - is' }),
                onSelect: () => { var _a; return filter.setValue({ in: (_a = filter.value) === null || _a === void 0 ? void 0 : _a.notIn }); },
            },
            {
                id: 'notIn',
                menuItem: t({ message: 'Is not', comment: 'Search: Filter operator - is not' }),
                label: t({ message: 'is not', comment: 'Search: Filter operator - is not' }),
                onSelect: () => { var _a; return filter.setValue({ notIn: (_a = filter.value) === null || _a === void 0 ? void 0 : _a.in }); },
            },
            {
                id: 'isNull',
                menuItem: t({ message: 'Has value', comment: 'Search: Filter operator - has value' }),
                label: t({ message: 'has', comment: 'Search: Filter operator - has value' }),
                onSelect: () => filter.setValue({ isNull: undefined }),
            },
        ]}/>

        {(filter.operator === 'in' || filter.operator === 'notIn') && (<MultiselectOperator name={name} projects={projects}/>)}

        {filter.operator === 'isNull' && <NullOperator name={name}/>}

        <ClearFilter name={name}/>
      </ButtonGroup>
    </Skeleton>);
}
